const fonts = require('google-fonts-complete');
import { defaultOptumUHCFontTypes } from 'types/types';

const getCombinedFontsForLogo = () => {
  const tempFonts = { ...fonts };
  Object.values(defaultOptumUHCFontTypes).forEach(value => {
    tempFonts[value] = {};
  });

  return Object.keys(tempFonts)
    .sort()
    .reduce((obj, key) => {
      obj[key] = tempFonts[key];
      return obj;
    }, {});
};

const getCombinedFontsForTheme = () => {
  const tempFonts = { ...fonts };
  //add new optum sans fonts.
  Object.values(defaultOptumUHCFontTypes)
    .slice(0, 3)
    .forEach(value => {
      tempFonts[value] = {};
    });

  return Object.keys(tempFonts)
    .sort()
    .reduce((obj, key) => {
      obj[key] = tempFonts[key];
      return obj;
    }, {});
};

export { getCombinedFontsForLogo, getCombinedFontsForTheme };
